$(function() {
  $(".headerV2 .headerV2-wrapper .nav-button").on("click", function() {
    $(".nav-overlay").toggleClass("open");
    var icon = $(this).find("i");
    if (icon) {
      if (icon.hasClass("fa-bars")) {
        icon.removeClass("fa-bars").addClass("fa-close");
      } else if (icon.hasClass("fa-close")) {
        icon.removeClass("fa-close").addClass("fa-bars");
      }
    }
  });

  $(window).resize(function() {
    if ($(window).width() > 991) {
      $(".nav-overlay").removeClass("open");
      $(".headerV2 .headerV2-wrapper .nav-button i")
        .removeClass("fa-close")
        .addClass("fa-bars");
    }
  });
});
